export default __webpack_public_path__ + "static/media/imperial.00ff7aad.png";